import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const InlineWrapper = styled.div`
  color: #de2f1b;
  font-size: 16px;
  font-weight: 500;
`;

const OptionButton = styled.button`
  color: inherit;
  font-size: inherit;
  font-weight: inherit;

  padding: 3px 4px;
  border: none;
  background: none;
  cursor: pointer;

  &:first-child {
    padding-left: 8px;
  }
`;

const InlineConfirmation = ({
  label,
  confirmOption,
  cancelOption,
  onConfirm,
  onCancel
}) => {
  return (
    <InlineWrapper>
      {label}
      <OptionButton type="button" onClick={onConfirm}>
        {confirmOption}
      </OptionButton>
      <OptionButton type="button" onClick={onCancel}>
        {cancelOption}
      </OptionButton>
    </InlineWrapper>
  );
};

InlineConfirmation.propTypes = {
  confirmOption: PropTypes.string,
  cancelOption: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

InlineConfirmation.defaultProps = {
  label: 'Are you sure?',
  confirmOption: 'Yes',
  cancelOption: 'No'
};

export default InlineConfirmation;
